// extracted by mini-css-extract-plugin
export default {"container":"lR-z","title":"mR-z","link":"nR-z"};